export abstract class CommonData {
    id: string = null;
    created_at: string;
    updated_at: string;
    deleted_at: string;
}
